import React from 'react'
import EnsHouseConsignmentsTable from './EnsHouseConsignmentsTable'
import { useFetchHouseConsignments } from '../../../../house-consignment/api/fetchHouseConsignments'

interface HouseConsignmentsTabProps {
  consignmentId: number
  interactionsLocked: boolean
}

function EnsHouseConsignmentsTab({ consignmentId, interactionsLocked }: Readonly<HouseConsignmentsTabProps>) {
  const { data: houseConsignments, isLoading } = useFetchHouseConsignments(consignmentId, !interactionsLocked)

  return (
    <div className="container-fluid py-3">
      <div className="consignments-card">
        <EnsHouseConsignmentsTable
          consignmentId={consignmentId}
          houseConsignments={houseConsignments ?? []}
          loading={isLoading}
        />
      </div>
    </div>
  )
}

export default EnsHouseConsignmentsTab
